import React, {Component} from 'react';
// import $ from 'jquery';
import PageLoader from './loader';
import MainComponent from './MainComponent';
import $ from "jquery";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {getAjax} from './../functions/functions.js';


class StatusCaptureEvents extends Component {
    // get_status_broadcast_notifications_logging

    constructor() {
        super();
        this.checkStatus();
    }

    componentWillUnmount() {
        clearInterval(this.state.check_status_interval);
    }

    checkStatus() {
        this.state = {
            check_status_interval: setInterval(() => {
                getAjax('?get_status_broadcast_notifications_logging&only_json', (data) => {
                        let data_json = JSON.parse(data);
                        let text = 'OFF';
                        if (data_json) {
                            text = 'ON';
                        } else {
                            text = 'OFF';
                        }
                        $('#status_capture_events').empty().append(text);
                    },
                    (e) => {
                        let text = 'OFF';
                        $('#status_capture_events').empty().append(text);
                    },
                );
            }, 1000)
        };
    }

    render() {
        return (
            <div id="status_capture_events">

            </div>
        );
    }
}

class AuthTableMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            table_state: props.table_state
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            table_state: nextProps.table_state
        });
    }

    enableCapturingEvents() {
        /*
        Change to Stop capturing... or get status by Ajax!
         */
        return () => {
            getAjax('?enable_broadcast_notifications_logging&only_json', (data) => {
                    console.log("Notifications enabled!");
                    let data_json = JSON.parse(data);
                    if (data_json) {
                        toast("Broadcast Notifications Enabled!");
                    } else {
                        toast("Broadcast Notifications Enable failed!");
                    }
                },
                (e) => {
                    toast("Broadcast Notifications Error...");
                },
            );
        }
    }

    disableCapturingEvents() {
        return () => {
            getAjax('?disable_broadcast_notifications_logging&only_json', (data) => {
                    let data_json = JSON.parse(data);
                    if (data_json) {
                        toast("Broadcast Notifications Disabled!");
                    } else {
                        toast("Broadcast Notifications Disable failed!");
                    }
                },
                (e) => {
                    toast("Broadcast Notifications Error...");
                },
            );
        }
    }

    deleteAllEvents() {

    }


    render() {
        if (!this.state.table_state.redis_data) {
            return (null);
        }
        let data = JSON.parse(this.state.table_state.redis_data);
        let nr_of_conn = Object.keys(data).length;
        return (
            <div>
                <div className="row">
                    <div className="col-md-2">
                        Total number of events: {nr_of_conn}
                    </div>

                    <div className="col-md-1">
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Actions
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a onClick={this.enableCapturingEvents()} className="dropdown-item" href="#">Capture
                                    Events</a>
                                <a onClick={this.disableCapturingEvents()} className="dropdown-item" href="#">Disable
                                    Capture Events</a>
                                <a onClick={this.deleteAllEvents()} className="dropdown-item" href="#">Delete All
                                    Events</a>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-1">
                        <StatusCaptureEvents/>
                    </div>
                </div>
                <ToastContainer/>
                <div className="clearfix"></div>
                <br/>
            </div>
        );
    }
}

class BroadcastNotifications extends MainComponent {
    constructor() {
        super();
        let thisComponent = this;

        this.state = {
            redis_data: this.noDataPreloader()
        };

        this.state = {
            'redis_load_data': setInterval(function () {
                thisComponent.loadData(global.mainDomainName + '?get_all_broadcast_notifications&only_json', (component, data) => {
                    if (typeof data === 'string') {
                        return;
                    }

                    // if (!isJson(data)) {
                    if (data || typeof data === 'object') {
                        thisComponent.setState({
                            redis_data: data
                        });
                    }
                });
            }, 1000)
        };
    }

    //

    componentWillUnmount() {
        let thisComponent = this;
        let interval_key = thisComponent.get('redis_load_data');
        clearInterval(interval_key);
    }

    generateTableRows() {
        {
            // let data = JSON.parse(this.state.redis_data);
            // console.log("Generating table rows..");
            // console.log(data);
            // console.log(Object.values(data));


            return Object.entries(this.state.redis_data).map((value, i) => {
                // console.log(value);
                // console.log(value[0]);
                let k = value[0];
                let v = value[1];

                // console.log(k.split(':'));

                let splitted_key = k.split(':');
                console.log(splitted_key);
                let created_key_time_ago = parseFloat((new Date().getTime() - splitted_key[5]) / 1000).toFixed(2);
                let crmid = splitted_key[2];
                let pos_underscore = crmid.indexOf('_');
                if (pos_underscore != -1) {
                    crmid = crmid.split('_')[0];
                }
                return (
                    <tr key={k}>
                        <td>{splitted_key[1]}</td>
                        <td>{crmid}</td>
                        <td>{splitted_key[3]}</td>
                        <td>{created_key_time_ago} s</td>
                        <td>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                    Action
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a className="dropdown-item" href="#">Delete Key</a>
                                    <a className="dropdown-item" href="#">Show Details</a>
                                </div>
                            </div>
                        </td>

                    </tr>
                );
            });
        }
    }

    noDataPreloader() {
        return (<PageLoader/>);
    }

    get_nr_of_conn() {
        let data = JSON.parse(this.state.redis_data);
        // console.log(data);
        // console.log('nr of conn: ' + data.length);
        return Object.keys(data).length;
    }

    render() {
        if (this.state.redis_data == null) return this.noDataPreloader();
        // console.log('rendering...');

        return (
            <div>
                <AuthTableMenu table_state={this.state}/>
                <table className="table">
                    <thead>
                    <tr>
                        <th scope="col">Listening Table Name</th>
                        <th scope="col">CRM ID</th>
                        <th scope="col">Type Event</th>
                        <th scope="col">Created Time For</th>
                        <th scope="col">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.generateTableRows()}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default BroadcastNotifications;



// WEBPACK FOOTER //
// ./src/components/BroadcastNotifications.js